import { useRequest } from 'domain/core/hooks/useRequest';
import { ApiMethodsEnum } from 'infrastructure/enums/ApiMethodsEnum';

export const COMPANIES_PER_PAGE = 12;

// The public ES search (`GET /companies`) is capped at ~10k results deep (guide §8) — pages
// past this return empty/error, so the browse pagination must not offer them.
export const ES_SEARCH_MAX_RESULTS = 10000;

export const useGetCompaniesList = () => {
  const { data, isLoading, error, send } = useRequest({
    method: ApiMethodsEnum.Get,
    sendOnStart: false,
  });

  const getCompaniesList = (
    search: string = '',
    page: number = 1,
    limit: number = COMPANIES_PER_PAGE
  ) => {
    const searchQuery = search ? `&search=${encodeURIComponent(search)}` : '';
    send({}, `/api/v1/companies?page=${page}&limit=${limit}${searchQuery}`).then();
  };

  return {
    getCompaniesList,
    data,
    isLoading,
    error,
  };
};
